module.exports = __webpack_public_path__ + "static/scan.1237b535.svg";